import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/layout/Layout';
import { ToastProvider } from './providers/ToastProvider';
import {
  Groups,
  Deployments
} from './components/pages';

function App() {
  return (
    <>
      <ToastProvider />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Navigate to="/deployments" replace />} />
          <Route path="deployments" element={<Deployments />} />
          <Route path="groups" element={<Groups />} />
          {/* Redirect unknown routes to deployments */}
          <Route path="*" element={<Navigate to="/deployments" replace />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
